import { motion } from "framer-motion";
import { Receipt, RefreshCcw, ShieldCheck, CheckCircle2 } from "lucide-react";

const FLOW = [
  { icon: Receipt, label: "Facturation client", desc: "Norton facture directement le client." },
  { icon: RefreshCcw, label: "Renouvellement des licences", desc: "Renouvellement automatique chaque année." },
  { icon: ShieldCheck, label: "Continuité de service", desc: "Protection ininterrompue, zéro friction." },
];

const SYSTEM_VISUAL =
  "https://images.unsplash.com/photo-1622151834677-70f982c9adef?crop=entropy&cs=srgb&fm=jpg&ixid=M3w3NTY2NzF8MHwxfHNlYXJjaHwxfHxpdCUyMHByb2Zlc3Npb25hbCUyMHdvcmtpbmclMjBsYXB0b3AlMjBkYXJrfGVufDB8fHx8MTc4MTY5Njc5OXww&ixlib=rb-4.1.0&q=85";

export default function AutomatedSystem() {
  return (
    <section id="automation" className="relative py-28 lg:py-36 px-6 md:px-12 bg-card/30 border-y border-white/5" data-testid="automation-section">
      <div className="max-w-7xl mx-auto grid lg:grid-cols-2 gap-16 items-center">
        <motion.div
          initial={{ opacity: 0, x: -30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
        >
          <span className="text-xs font-bold uppercase tracking-[0.2em] text-norton-yellow">
            Sans contrainte
          </span>
          <h2 className="text-3xl sm:text-4xl font-heading font-semibold tracking-tight mt-4 leading-tight">
            Un système 100 % automatisé
          </h2>
          <p className="text-zinc-400 mt-5 text-lg leading-relaxed">
            Norton gère l'ensemble du cycle de renouvellement. Vous n'avez rien à faire
            après la vente initiale, tout en continuant à être rémunéré.
          </p>

          <div className="mt-10 space-y-4">
            {FLOW.map((f, i) => (
              <motion.div
                key={f.label}
                initial={{ opacity: 0, y: 16 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true }}
                transition={{ duration: 0.4, delay: i * 0.12 }}
                className="flex items-start gap-4 rounded-xl border border-white/10 bg-card/60 p-5 transition-colors hover:border-norton-yellow/30"
                data-testid={`flow-item-${i + 1}`}
              >
                <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-lg bg-norton-yellow/10 text-norton-yellow">
                  <f.icon className="h-5 w-5" />
                </div>
                <div>
                  <div className="font-heading font-semibold">{f.label}</div>
                  <div className="text-sm text-zinc-400 mt-0.5">{f.desc}</div>
                </div>
              </motion.div>
            ))}
          </div>
        </motion.div>

        <motion.div
          initial={{ opacity: 0, x: 30 }}
          whileInView={{ opacity: 1, x: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="relative"
        >
          <div className="relative rounded-3xl overflow-hidden border border-white/10">
            <img src={SYSTEM_VISUAL} alt="Gestion automatisée des renouvellements" className="w-full h-[460px] object-cover" />
            <div className="absolute inset-0 bg-gradient-to-t from-black/90 via-black/20 to-transparent" />

            <div className="absolute bottom-6 left-6 right-6 rounded-2xl border border-white/15 bg-black/60 backdrop-blur-xl p-5">
              <div className="flex items-center gap-3">
                <CheckCircle2 className="h-6 w-6 text-norton-yellow" />
                <div>
                  <div className="font-heading font-semibold text-white">Aucune relance nécessaire</div>
                  <div className="text-sm text-zinc-400">Norton s'occupe des renouvellements automatiquement.</div>
                </div>
              </div>
            </div>
          </div>
          <div className="absolute -z-10 -top-8 -right-8 h-40 w-40 rounded-full bg-norton-yellow/20 blur-3xl" />
        </motion.div>
      </div>
    </section>
  );
}
